import { ReactNode } from 'react';
import { VoyagersClubProps } from '../voyagersclub/VoyagersClubProps';
import { PriceToasterMessage } from '../cabinmacrocategory/CabinMacroCategoryProps';

type GuestContainerProps = {
  id?: string;
  firstAdultInputFields: GuestContainerFormFields;
  childInfantInputFields: GuestContainerFormFields;
  otherAdultInputFields: GuestContainerFormFields;
  guestNumberLabelPlaceholder?: string;
  documentTypeInputFields: any;
  alertDescription: string;
  alertAgeIcon?: string;
  alertNotesLabels?: {
    'jcr:primaryType'?: string;
    elementLabel?: string;
    elementType?: string;
  }[];
  adultAgeRestrictionReminder?: string;
  adultAgeNoRestrictionReminder?: string;
  minorAgeRestrictionReminder?: string;
  ageRestrictionErrorToasterTitle?: string;
  ageRestrictionErrorToasterMessage?: string;
  showAgeRestrictionErrorToasterIcon?: boolean;
  enableAgeRestrictionErrorToasterCloseButton?: boolean;
  invalidFormToasterTitle?: string;
  invalidFormToasterMessage?: string;
  children?: ReactNode;
  infoContainerToggleIconTooltip?: string;
  calendarIconAccessibilityLabel?: string;
  priceToasterMessage?: PriceToasterMessage;
  disableSaveAndContinueButton?: boolean;
  subscribersCheckbox?: SubscribersCheckbox;
  guestInformationFormAccessibilityLabel?: string;
} & VoyagersClubProps;

type FormGuestData = {
  passengers: GuestData[];
};

type GuestData = {
  cabinIndex?: number;
  firstName?: string;
  lastName?: string;
  dateOfBirth?: string;
  age?: number;
  email?: string;
  confirmEmail?: string;
  phone?: string;
  prefix?: string;
  gender?: string;
  countryOfResidence?: string;
  documentType?: string;
  documentNumber?: string;
  dateOfExpire?: string;
  nationality?: string;
  countryOfIssue?: string;
  passportDateOfIssue?: string;
  type?: string;
  typeNumber?: number;
  number?: number;
  leadPassenger?: boolean;
  marketingConsent?: boolean;
};

type SubscribersCheckbox = {
  isSubscribersCheckboxVisible?: boolean;
  subscribersCheckboxDescription?: string;
  isSubscribersCheckboxSelected?: boolean;
};

export enum GuestType {
  ADULT = 'adult',
  MINOR = 'minor',
  INFANT = 'infant',
}

export interface GuestContainerFormFields {
  dropdownItems: any[];
  childInputs: ChildInput[];
  resourceType: string;
}

export interface ChildInput {
  name: string;
  secondName?: string;
  type: string;
  helpMessage?: string;
  secondHelpMessage?: string;
  validationRulesContainer?: ValidationRulesContainer[];
  label: string;
  secondLabel?: string;
  value: string | number | readonly string[];
  selectTypeOfDate?: string;
  dropdownItems: DropdownItem[];
  childInputs: any[];
  resourceType: string;
  enablePrefixSearch?: boolean;
  showPrefixFlags?: boolean;
  useNativeSelect?: boolean;
  isMandatory?: boolean;
  noCopyPaste?: boolean;
  isCoRPrefilledAndDisabled?: boolean;
  placeHolderSelect?: string;
  isMandatoryErrorMessage?: string;
  invalidDateErrorMessage?: string;
  items?: any[];
  readOnly?: boolean;
  text?: string;
  verifyZipCodeButtonLabel?: string;
  zipCodeValidationErrorMessage?: string;
  cityValidationErrorMessage?: string;
  appliedCssClassNames?: string;
}

export interface ValidationRulesContainer {
  'jcr:primaryType'?: string;
  validationRules: string;
  validationRuleErrorMessage: string;
  customValidation?: string;
}

export interface DropdownItem {
  text: string;
  value: string;
  selected: boolean;
}

export interface AdditionalValidationFields {
  embarkationDate?: string;
  disembarkationDate?: string;
  guestType?: string;
  email?: string;
  minimumAge?: number;
  leadPaxAgeRestrictionErrorMessage?: string;
  minimumAgeDateOfBirth?: number;
  disableCheckAgePopupLightLogin?: boolean;
  guestName?: string;
  guestSurname?: string;
}

export type { GuestContainerProps, GuestData, FormGuestData };
